import { useLoginData } from "component/common/loginData";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getMyUnreadNotification } from "store/slice/auth";

const RouteApiListener = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = useLoginData();
  useEffect(() => {
    if (
      location.pathname != "/login" &&
      location.pathname != "/signup" &&
      location.pathname != "/forgot-password" &&
      userData
    ) {
      dispatch(getMyUnreadNotification());
    }
  }, [location.pathname]);

  return null;
};

export default RouteApiListener;
